export default __webpack_public_path__ + "images/6ea15eb9a89a3a22321eb28f0a588ae3-error.png";